module.exports = __webpack_public_path__ + "static/img/2.e0bec5d3.png";